<template>
  <div class="services-card">
    <va-card title="Services">
      <no-clients></no-clients>
      <va-accordion>
        <va-collapse customHeader>
          <span slot="header">
            <va-button :outline="true" :color="$themes.primary"
              :iconRight="`fa fa-angle-down va-collapse__header__icon`">
              Separation Anxiety
            </va-button>
          </span>
          <div slot="body" class="service-description">
            <separation-anxiety-description />
            <router-link to="/services/separation-anxiety" class="link-to-services">
              <va-button class="learn-more-button">
                Learn More
              </va-button>
            </router-link>
          </div>
        </va-collapse>
        <va-collapse customHeader>
          <span slot="header">
            <va-button :outline="true" :color="$themes.primary"
              :iconRight="`fa fa-angle-down va-collapse__header__icon`">
              Basic Manners Package
            </va-button>
          </span>
          <div slot="body" class="service-description">
            <p class="display-3">$360</p>
            <div>
              In this 4 session package, you will learn how to teach your dog skills for calm, polite behaviors inside the house and outside.
              Your dog will learn hand targeting, sit, down, leave it, stay, go to place, drop it, loose leash walking, coming when called,
              polite greetings, and more!
            </div>
            <div>
              What's included:
              <ul>
                <li>4 private lessons <div class="italic">(3 basic manners lessons, 1 bonus lesson of your choice)</div></li>
                <li>Customized weekly homework with action items</li>
                <li>Unlimited mid-week support via messaging app of your choice</li>
                <li>Support, cheerleading, & coaching</li>
              </ul>
            </div>
            <!-- <va-button @click="openModal()" class="request-button">Request to enroll</va-button> -->
          </div>
        </va-collapse>
        <va-collapse customHeader>
          <span slot="header">
            <va-button :outline="true" :color="$themes.primary"
              :iconRight="`fa fa-angle-down va-collapse__header__icon`">
              Private sessions
            </va-button>
          </span>
          <div slot="body" class="service-description">
            <p class="display-3">$100 in person / $90 virtual</p>
            <div>
              In-person private sessions are available at a location of your choice in Boulder, Superior, Louisville, Erie, and Lafayette, Colorado. Virtual sessions are available for those outside our service area or for anyone who wants one.
            </div>
            <div>
              In-person private sessions are an opportunity to get personalized coaching with hands on practice for you and your dog.
            </div>
            <div>
              Virtual sessions are an opportunity to get personalized coaching from the comfort of your own home.
              This can be a great option for dogs that are fearful of new people to learn where they are most comfortable (which will help them learn better and faster!).
            </div>
            <div>
              Topics we can cover include:
              <ul>
                <li>Basic manners</li>
                <li>Reactivity</li>
                <li>Loose leash walking</li>
                <li>Coming when called</li>
                <li>Jumping</li>
                <li>Calmness</li>
                <li>Resource guarding</li>
                <li>Crate training</li>
                <li>Introducing a new dog to the home</li>
              </ul>
              <div>
                If you are interested in working on your dog's separation anxiety, learn more
                <router-link to="/services/separation-anxiety" class="link-to-services">here</router-link>.
              </div>
            </div>
            <!-- <router-link v-if="linkToScheduler" to="/services" class="link-to-services">
              <va-button style="width: 100%;">
                Schedule a Session
              </va-button>
            </router-link> -->
          </div>
        </va-collapse>
        <!-- <va-collapse customHeader>
          <span slot="header">
            <va-button :outline="true" :color="$themes.primary"
              :iconRight="`fa fa-angle-down va-collapse__header__icon`">
              Group classes
            </va-button>
          </span>
          <div slot="body" class="service-description">
            <h2 class="group-class">Basic Manners</h2>
            <basic-manners-classes />
            <h2 class="group-class">Outside Manners</h2>
            <outside-manners-classes />
            <router-link :to="{name: 'all-group-classes'}" class="all-group-classes">
              <va-button>
                View all group classes
              </va-button>
            </router-link>
          </div>
        </va-collapse> -->
      </va-accordion>
      <va-modal v-model="showModal" title="Request to Enroll in Basic Manners Package" :message="modalMessage"
        position="top" size="large" hide-default-actions>
        <basic-manners-package-form @sent-request="closeModal" />
        <div class="cancel-button" style="display: flex; justify-content: center;">
          <va-button flat color="gray" @click="closeModal">
            Cancel
          </va-button>
        </div>
      </va-modal>
      <!-- <router-link v-if="linkToScheduler" to="/services" class="link-to-services">
        <va-button style="width: 100%;">
          Schedule a Session
        </va-button>
      </router-link> -->
    </va-card>
  </div>
</template>

<script>
import BasicMannersPackageForm from '../forms/BasicMannersPackageForm'
// import BasicMannersClasses from '../sub-components/BasicMannersClasses.vue'
// import OutsideMannersClasses from '../sub-components/OutsideMannersClasses.vue'
import SeparationAnxietyDescription from '../sub-components/SeparationAnxietyDescription.vue'
import NoClients from '../sub-components/NoClients'

export default {
  name: 'services-card',
  components: {
    BasicMannersPackageForm,
    // BasicMannersClasses,
    // OutsideMannersClasses,
    SeparationAnxietyDescription,
    NoClients,
  },
  data () {
    return {
      showModal: false,
      modalMessage: 'Request to join class',
    }
  },
  computed: {
    linkToScheduler () {
      return (this.$route.name !== 'services')
    },
  },
  methods: {
    openModal () {
      this.modalMessage = 'Request to enroll in the 4 week basic manners package.'
      this.showModal = true
    },
    closeModal () {
      this.showModal = false
    },
  },
}
</script>

<style scoped lang="scss">
.services-card {
  .va-card__body {
    display: flex;
    flex-direction: column;
    align-items: center;

    .va-button {
      border-radius: 0.375rem;
      max-width: 90%;
      width: 90%;
      margin-left: 1rem;

      &__content {
        font-size: 1.3rem;
        font-family: Montserrat, sans-serif;

        &__title {
          font-size: 1.3rem;
        }
      }
    }

    .learn-more-button {
      margin: 2rem;
    }

    .all-group-classes {
      display: flex;
      justify-content: center;
      margin-top: 1rem;

      .va-button {
        border-radius: 0.375rem;
        max-width: 90%;
        width: 90%;
        margin-left: 1rem;

        @include media-breakpoint-up(lg) {
          width: 50%;
        }

        &__content {
          font-size: 1.3rem;
          font-family: Montserrat, sans-serif;

          &__title {
            font-size: 1.3rem;
          }
        }
      }
    }

    .service-description {
      div {
        margin-top: 1rem;
      }

      ul {
        margin-left: 2rem;

        li {
          list-style: circle;

          .italic {
            margin-top: 0;
            font-style: italic;
          }
        }
      }

      .request-button {
        margin-top: 2rem;
      }

      .group-class {
        text-align: center;
      }
    }

    span {
      margin-top: 1rem;
      text-align: center;
    }

    .link-to-services {
      margin-top: 2rem;
    }
  }
}
</style>
